import Article from './OnlyHtmlArticle';

export { default as ArticleTheme } from './OnlyHtmlArticle.styled';
export default Article;
